<template>
  <DialogConfirmation ref="dialogConfirmation"/>
  <div class="row accordion-element">
    <div class="col">  
      <Accordion>
        <AccordionTab>
              <template #header>
                <div v-if="isDisponible">
                  <td>Pièces jointes (Quantité : {{ tailleListeMultimedia }})</td>
                </div>
                <div v-else>
                  <td>Pièces jointes (Non disponible)</td>
                </div>
                <vue-loaders v-if="isDataLoading" name="ball-beat"></vue-loaders>
              </template>
              <div class="row file-uploader" >
                <div class="col-2">
                  <FileUpload
                    mode="basic"
                    :accept="ALLOWED_FILETYPES"
                    chooseLabel="Sélectionner un fichier"
                    class="p-button-sm p-button-rounded"
                    :customUpload="CUSTOM_UPLOAD"
                    :auto="AUTO_UPLOAD"
                    @uploader="multimediaLie"
                    ref="fileUpload"
                  />
                </div>
                <div class="col-6"></div>
              </div>
              <DataTable
                class="p-datatable-sm"
                :value="listeMultimedia"
                :resizableColumns="true"
                columnResizeMode="fit"
                :reorderableColumns="true"
                sortField="cle"
                :sortOrder="-1"
                responsiveLayout="scroll"
                :scrollableY="true"
                scrollHeight="500px"
                dataKey="cle"
              >
              <Column
                field="description"
                header="Description"
                :sortable="true"
                class="table-txt-wrap"
                @click="onSelect"
              >
                <template #body="slotProps">
                  <label class="hyperlink underline" @click="onSelect(slotProps.data)">{{slotProps.data.description}}</label>
                </template>
              </Column>
              <Column
                field="creerPar"
                header="Créé Par"
                :sortable="true"
                class="table-txt-wrap"
              ></Column>
              <Column
                field="creerLe"
                header="Date de création"
                :sortable="true"
                class="table-txt-wrap"
              >
                <template #body="slotProps">
                  {{
                    $commun.formatDateHeure(
                      slotProps.data.creerLe
                    )
                  }}
                </template>
              </Column>
                <Column headerStyle="width: 3rem" :exportable="false">
                  <template #body="slotProps">
                    <div>
                      <Button
                          icon="pi pi-trash"
                          class="p-button-datatable p-button-sm"
                          @click="confirmerSuppression(slotProps)"
                      />
                    </div>
                  </template>
                </Column>
            </DataTable>
        </AccordionTab>
      </Accordion>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {mapState} from "vuex";
import DialogConfirmation from '../../../../components/Commun/DialogConfirmation.vue';

export default {
  name: 'AuditPiecesJointes',
  components: {
    DialogConfirmation
  },
  data() {
    return {
      isDataLoading: false,
      isDisponible: true,
      multimediaASupprimer: null,
      indexSuppression: 0,
      multimediasLies: []
    }
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
  },
  created() {
    this.ALLOWED_FILETYPES = "application/*, image/*"
    this.AUTO_UPLOAD = true
    this.CUSTOM_UPLOAD = true
  },
  computed: mapState({
    state (state) {
      return state[this.storeModule]
    },
    jeton (state, getters) {
      return getters['cardex/jeton']
    },
    profil(state, getters){
      return getters['cardex/profil']
    },
    tailleListeMultimedia() {
      return this.multimediasLies.length
    },
    listeMultimedia() {
      return this.multimediasLies
    },
  }),  
  methods: {
    getJustificationFichier() {
      return this.multimediasLies;
    },
    clearJustification() {
      this.multimediasLies.splice(0);
    },
    confirmerSuppression(slotProps) {
      this.indexSuppression = slotProps.index;
      this.$confirm.require({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: "Voulez-vous supprimer le fichier lié?",
        accept: this.multimediaSupprimer,
        reject: () => {},
      })
    },
    multimediaSupprimer() {
      this.multimediasLies.splice(this.indexSuppression, 1);
    },
    onSelect(event){
      var arr = event.donnees;	
      const linkSource = `data:application/pdf;base64,${arr}`;
      const downloadLink = document.createElement("a");
      const fileName = event.description;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },
    multimediaLie(monObj) {
      let file = monObj.files[0];
      let extentionImage = file.name.split('.')[file.name.split('.').length-1];

      let nouvelleImg = {
        cle : null,
        site : null,
        confidentialite: null,
        sourceCle : this.$route.params.cle,
        multimediaCle : null,
        multimediaSite : null,
        numero : null,
        type : 18826,
        description : file.name,
        extension : extentionImage,
        selectionner : null,
        donnees : URL.createObjectURL(file),
        creerPar : null,
        creerLe : null,
        modifierPar : null,
        modifierLe : null
      }
      this.$store.dispatch('multimedia/obtenirPhotoBlobAction', {
        multimedia: nouvelleImg
      })
          .then(() => {
            this.$refs.fileUpload.clear();
            this.multimediasLies.push(nouvelleImg);
          })
    },
  }
}
</script>